import React from 'react';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';
interface PageProps {
    list: { title: string, icon: string, description: string }[],
}
const Chellenge: React.FC<PageProps> = ({ list }) => {
    return (
        <div className="aimed-chellenge-page">
            <FullWrapper caseName="aimed-chellenge-pageCase">
                <div className="aimed-chellenge-pageWrapper">
                    <div className="aimed-chellenge-pageMainTitle">Вызовы проекта</div>
                    <div className="aimed-chellenge-pageList">
                        {list &&
                            list.map(item => (
                                <div className="aimed-chellenge-pageItem" key={item.title}>
                                    <div className="aimed-chellenge-pageIcon">
                                        <img src={item.icon} alt={item.title} />
                                    </div>
                                    <div
                                        className="aimed-chellenge-pageTitle"
                                        dangerouslySetInnerHTML={{ __html: item.title }}
                                    ></div>
                                    <div
                                        className="aimed-chellenge-pageDescription"
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                    ></div>
                                </div>
                            ))}
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Chellenge;
